import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface AssetMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AssetMst {
    id?: any;
 
    name: string;
    assetTypeId: Number;
    tenantId: any;
    branchId: any;
    assetSubType: any;
    assetBrand:string;
    assetLocation: string;
    custodian: any;
    serialNo: string;
    manufacturerModel:string;
    lifeCycleExpDate: any;
    warrantyExpDate: any;
    assetOwnerGroup: any;
    notes: string;
    owningType: string;
    venderId: any;
    purchaseDate: any;
    poNo: string;
    purPrice: any;
    amcPrice: any;
    amcStartDate: any;
    amcEndDate:any;
    leasingAmt: any;
    leasingStartDate: any;
    leasingEndDate: any;
    createdBy: any;
    createdDate: any;
    updatedBy:any;
    udatedDate: any;
 
    parameters?: AssetMstParameter[];
    links?: any;
}

export abstract class AssetMstData {
   
    abstract list(url: string): Observable<AssetMst[]>;
    abstract create(url: string, data: AssetMst): Observable<AssetMst[]>;
    abstract update(url: string, data: AssetMst): Observable<AssetMst>;
    abstract delete(url: string): Observable<any>;
}